import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-brand-selection-desktop',
  templateUrl: './desktop.component.html',
  styleUrls: ['./desktop.component.scss'],
})
export class BrandSelectionDesktopComponent {
  @Output() changeSelectedSupplier = new EventEmitter();

  @Output() bookReturn = new EventEmitter();

  @Input() searchTerm: any;

  @Input() suppliers$: any;

  @Input() selectedSupplier$: any;

  @Input() searchSuppliers$: any;

  @Input() selectedSupplierId: any;

  @Input() failed: any;
}
